<button type="button" class="info-button" [ngbPopover]="popTemplate"
        triggers="mouseenter:mouseleave" placement="auto" [container]="container || null"
        [popoverClass]="'info-popover'">
  <i class="fa fa-question-circle"></i>
</button>

<ng-template #popTemplate>{{info}}</ng-template>
